import { render, staticRenderFns } from "./statisticsOverdueDays.vue?vue&type=template&id=3c5a2818&scoped=true&"
import script from "./statisticsOverdueDays.vue?vue&type=script&lang=js&"
export * from "./statisticsOverdueDays.vue?vue&type=script&lang=js&"
import style0 from "./statisticsOverdueDays.vue?vue&type=style&index=0&id=3c5a2818&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a2818",
  null
  
)

export default component.exports